module.exports = __webpack_public_path__ + "mx.434d6364.svg";